import { render, staticRenderFns } from "./SignPage.vue?vue&type=template&id=f222577c&scoped=true"
import script from "./SignPage.vue?vue&type=script&lang=ts"
export * from "./SignPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f222577c",
  null
  
)

export default component.exports